export const resolvePathParams = <
  TInput extends Record<string, unknown>,
  TOutput extends Partial<TInput> = TInput,
>(
  routePattern: string,
  data: TInput
): [string, TOutput | undefined] => {
  let url = routePattern;
  const newData = { ...data } as Partial<TInput>;

  url = url.replace(/:([^/]+)/g, (_, key) => {
    if (key in newData) {
      const value = String(newData[key]);
      delete newData[key];
      return encodeURIComponent(value);
    }

    return `:${key}`;
  });

  if (Object.keys(newData).length === 0) {
    return [url, undefined];
  }

  return [url, newData as TOutput];
};

export const hasPathParams = (route: string) => {
  return /\/:[^/]+/.test(route);
};
